var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpenseManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19",
    "data-name": "Layer 19",
    transform: "translate(-3.999 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24868",
    "data-name": "Path 24868",
    d: "M26.666,13.314a1.335,1.335,0,0,0,.947-.386L32,8.537v2.116a1.333,1.333,0,0,0,2.667,0V5.331A1.353,1.353,0,0,0,33.332,4H28a1.331,1.331,0,1,0,0,2.661h2.12l-4.4,4.378a1.331,1.331,0,0,0,.947,2.275Zm9.066,3.752a1.355,1.355,0,0,0-2.667.479A13.34,13.34,0,1,1,20,6.661a12.131,12.131,0,0,1,1.213,0,1.333,1.333,0,0,0,1.453-1.144,1.331,1.331,0,0,0-1.213-1.45H20A15.961,15.961,0,1,0,35.732,17.133Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000127736869356276977400000010254600488177106082_",
    transform: "translate(14.328 14.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rupee"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24870",
    "data-name": "Path 24870",
    d: "M78.667,15.853a1.057,1.057,0,0,1-.776-.339L71.983,9.151a1.059,1.059,0,0,1,.776-1.779h2.924a2.58,2.58,0,0,0,2.351-1.52h-4.3a1.059,1.059,0,0,1,0-2.117H78.03a2.579,2.579,0,0,0-2.348-1.517H72.759a1.059,1.059,0,0,1,0-2.117h9.223a1.059,1.059,0,0,1,0,2.117H79.606a4.612,4.612,0,0,1,.649,1.517h1.73a1.059,1.059,0,0,1,0,2.117H80.258a4.706,4.706,0,0,1-4.576,3.641H75.19l4.256,4.585a1.059,1.059,0,0,1-.055,1.5A1.08,1.08,0,0,1,78.667,15.853Z",
    transform: "translate(-71.7 -0.1)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseManagement);
export default __webpack_public_path__ + "static/media/ExpenseManagement.76cb8be31238202618d69f15ff18c643.svg";
export { ForwardRef as ReactComponent };